'use strict';

module.exports = ['$scope', '$rootScope', '$exceptionHandler', '$http', '$interval', 'moment', '$auth', function($scope, $rootScope, $exceptionHandler, $http, $interval, moment, $auth) {
	$scope.people = {};
	$scope.lastUpdate = moment.unix(jsonPreload.now);
	$scope.refreshInterval = jsonPreload.refreshInterval;
	
	var now = moment.utc();
	$scope.diff = now - $scope.lastUpdate;
	
	//console.log(serverNow._d, now._d);
	
	jsonPreload.people.forEach(function (item) {
		item.lastSeen = item.lastSeen ? moment(moment.unix(item.lastSeen) + $scope.diff) : null;
		$scope.people[item.id] = item;
		//console.log(item.lastSeen._d, now._d);
	});
	
	//console.log($scope.people);
	
	$scope.$on('loginChanged', function() {
		$scope.token = $rootScope.token;

		if ($scope.token) {
			//var encodedPayload = $scope.token.split('.')[1];
			//$scope.user = JSON.parse(atob(encodedPayload));
			$scope.user = $auth.getPayload();
			//console.log($scope.user);
		} else {
			delete $scope.user;
		}
	});

	$scope.presentLabel = function(person) {
		if (!person.presentLabel) {
			var phrases = [
				"Ooo! Here!", "Here!", "Yuh-huh!", "Haaaaaai~!", "Present!", "What? Oh, here.", "Yep!", "Yeah!", "Yo!"
			];

			person.presentLabel = phrases[Math.floor(Math.random() * phrases.length)];
		}

		return person.presentLabel;
	};

	$scope.isPresent = function(person) {
		if (!person.lastSeen) {
			return false;
		}
		
		var diff = moment.utc().diff(person.lastSeen, 'hours', true);
		if (diff < 2.0) {
			//console.log(person.name, diff);
			return true;
		} else {
			return false;
		}
	};

	$scope.isMine = function(person) {
		if ($scope.user == null || $scope.user.sub == null || person.owner == null || person.owner.sub == null) {
			return false;
		}

		return ($scope.user.sub == person.owner.sub);
	};
	
	$scope.isPresentComparitor = function(person) {
		if ($scope.isPresent(person)) {
			return -1;
		} else {
			return 1;
		}
	};
	
	$scope.presentClicked = function(person) {
		sendPresent([person.id]);
	};

	$scope.dismissSelfClicked = function(person) {
		$http({
			method: "DELETE",
			url: "api/people/attendance/" + person.id
		}).then(function success(response) {
			//console.log("success", response);

			var item = response.data;
			if (item.lastSeen) {
				item.lastSeen = moment(moment.unix(item.lastSeen) + $scope.diff);
			}

			$scope.people[item.id] = item;
		}, function failure(response) {
			console.log("Dismiss Self Clicked failure", response);
		});
	};
	
	$scope.allPresentClicked = function() {
		sendPresent(getMyIds());
	};

	// This implementation is a bit lazy, but it's unlikely to happen
	$scope.allDismissSelfClicked = function() {
		var ids = getMyIds();
		ids.forEach(function (id) {
			$http({
				method: "DELETE",
				url: "api/people/attendance/" + id
			}).then(function success(response) {
				//console.log("success", response);

				var item = response.data;
				if (item.lastSeen) {
					item.lastSeen = moment(moment.unix(item.lastSeen) + $scope.diff);
				}

				$scope.people[item.id] = item;
			}, function failure(response) {
				console.log("Dismiss Self Clicked failure", response);
			});
		});
	};

	function getMyIds() {
		if (!($scope.user && $scope.user.sub)) {
			return [];
		}

		var ids = [];
		for (var key in $scope.people) {
			if ($scope.people.hasOwnProperty(key)) {
				var person = $scope.people[key];

				if (person.owner && person.owner.sub == $scope.user.sub) {
					//console.log(person);
					ids.push(person.id);
				}
			}
		};

		return ids;
	}

	function sendPresent(ids) {
		$http({
			method: "POST",
			url: "api/people/attendance",
			data: {"ids": ids}
		}).then(function success(response) {
			response.data.forEach(function (item) {
				if (item.lastSeen) {
					item.lastSeen = moment(moment.unix(item.lastSeen) + $scope.diff);
				}

				$scope.people[item.id] = item;
			});
		}, function failure(response) {
			console.log("Present Clicked failure", response);
		});
	}

	$interval(function() {
		//console.log($scope.lastUpdate);
		
		$http({
			method: "GET",
			url: "api/people/since/" + $scope.lastUpdate.unix()
		}).then(function success(response) {
			if (response.data.changes) {
				response.data.changes.forEach(function (item) {
					if (item.deleted) {
						delete $scope.people[item.id];
					} else {
						if (item.lastSeen) {
							item.lastSeen = moment(moment.unix(item.lastSeen) + $scope.diff);
						}
						
						$scope.people[item.id] = item;
					}
				});
			}
			
			if (response.data.now) {
				$scope.lastUpdate = moment.unix(response.data.now);
			} else {
				console.log("Missing response.data.now");
			}
		}, function failure(response) {
			console.log("Interval update failure", response);
		});
	}, $scope.refreshInterval);
}];
